
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/new-arrivals",
      function () {
        return require("private-next-pages/shop/new-arrivals/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/new-arrivals"])
      });
    }
  